import React, { createContext, useEffect } from "react";

export const CreatorModeContext = createContext();

const CREATOR_MODE_STORAGE_KEY = "creatorModeEnabled";

// Creator Mode UI has been removed from the dashboard in favor of downloadable
// desktop editors. Keep a no-op provider so existing tool pages that still
// read this context do not break.
export default function CreatorModeProvider(props) {
  useEffect(() => {
    localStorage.removeItem(CREATOR_MODE_STORAGE_KEY);
    localStorage.removeItem("creatorModeTogglePosition");
  }, []);

  const value = {
    isCreatorMode: false,
    toggleCreatorMode: () => {},
    enableCreatorMode: () => {},
    disableCreatorMode: () => {},
    setNavigationHandler: () => {},
  };

  return (
    <CreatorModeContext.Provider value={value}>
      {props.children}
    </CreatorModeContext.Provider>
  );
}
